import { useQuery } from '@tanstack/react-query';
import { isArray } from 'lodash';
import { generateQuery } from 'src/utils';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';
import { mapScreenSections } from './helpers';

export const useGetScreenSections = () =>
  useQuery({
    queryKey: queryKeys.screenSections.all(),
    queryFn: fetchScreenSections,
    staleTime: Infinity,
  });

export const fetchScreenSections = async () => {
  const response = await requestCCApi({
    url: '/screenSections?include=sections,screens&pageSize=0',
  });

  return mapScreenSections(response);
};

export const fetchOptimisedScreenSections = async (
  screenId?: number | number[],
) => {
  const response = await requestCCApi({
    url: `/screenSections${generateQuery(
      ['sections', 'screens'],
      [
        'pageSize=0',
        screenId
          ? `screen_id.list=${
              isArray(screenId) ? screenId.join('|') : screenId
            }`
          : '',
      ],
    )}`,
  });

  return mapScreenSections(response);
};
